<template>
    <div class="nav__list"
         v-if="pages"
    >
        <div
            class="nav__section"
        >
            <template v-for="(page, index) in pages">
                <a class="nav__item"
                   v-if="isVisiblePage(page) && (isAuth && page.auth) || !page.auth"
                   :href="render ? domain + prefix + page.href : '' + prefix + page.href"
                   :class="{'nav__item--create-page' : page.button && isUserTree(page)}"
                   :key="index">
                    <svg v-if="iconPlusVisible(page)"
                         width="11" height="11">
                        <use xlink:href="/assets/front/img/sprite.svg#icon-plus_nav"></use>
                    </svg>
                    <a
                        :href="render ? domain + prefix + page.href : '' + prefix + page.href"
                        class="nav__link"
                        :class="{
                            'nav__link--active': page.href === $route.path,
                            'nav__last-child': isLastChild(page)
                            }"
                    >
                        <span v-if="isUserTree(page)"> {{ page.name }} </span>
                    </a>
                </a>
            </template>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
export default {
    name: 'HeaderPages',
    props: {
        render: false,
        pages: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            domain: window.laravel.appUrlByLocale,
            prefix: window.laravel.prefix,
            isAdmin: window.laravel.isAdmin,
            isPartner: window.laravel.isPartner,
            isMaster: window.laravel.isMaster,
        }
    },
    computed: {
        ...mapState('header', [
            'headerPages'
        ]),
        ...mapGetters('auth', [
            'isAuth'
        ]),
        isNotUser() {
            return this.isAdmin || this.isPartner || this.isMaster
        }
    },
    methods: {
        isVisiblePage(page) {
            const hasAttr = Object(page).hasOwnProperty('visible');

            return hasAttr && page.visible || !hasAttr;
        },
        isUserTree(page) {
            return !(page.href === '/cabinet/tree' && (this.isAdmin || this.isPartner || this.isMaster))
        },
        isLastChild(page) {
            return page.href === '/memories#moments' && !this.isAuth || page.href === '/place#why' || page.href === '/contacts#support'  || (page.href === '/familytree#faq' || page.href === '/cabinet/tree') && this.isNotUser
        },
        iconPlusVisible(page){
            return page.href === '/create/tariffs' || page.href === '/cabinet/page/add'
        }
    }
}
</script>
